module.exports = __webpack_public_path__ + "img/filter-filled-tool-symbol.591d494d.svg";